import DesktopBrowserConfigurator from './DesktopBrowserConfigurator';

export default DesktopBrowserConfigurator;
